import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import SpotlightCard from '../ui/SpotlightCard';

export default function FaqSection() {
  const faqs = [
    {
      question: 'A JWCosta atende empresas de quais portes?',
      answer: 'Atendemos desde startups e PMEs em fase de tração até grandes indústrias e corporações que necessitam de auditoria digital avançada e conformidade de alto nível.'
    },
    {
      question: 'Como funciona a transição de contabilidade?',
      answer: 'Temos um time de Onboarding dedicado. Todo o processo de migração da sua contabilidade atual para a JWCosta é feito de forma transparente, digital e sem interromper a sua operação.'
    },
    {
      question: 'Vocês realizam BPO Financeiro?',
      answer: 'Sim. Nosso BPO Financeiro integra perfeitamente com a contabilidade, fornecendo dashboards gerenciais, controle de contas a pagar/receber e conciliação bancária diária.'
    },
    {
      question: 'Como a Reforma Tributária afetará minha empresa?',
      answer: 'Nossa equipe jurídica e contábil já está estruturando o plano de transição para o IBS/CBS para todos os clientes, garantindo a escolha do melhor regime tributário.'
    }
  ];

  const [activeIndex, setActiveIndex] = useState(null);

  return (
    <section id="faq" className="w-full bg-background py-32 border-t border-foreground/5">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div 
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-black text-foreground tracking-tighter mb-6">
            Dúvidas Frequentes
          </h2>
          <p className="text-xl text-slate-400 font-medium">
            Respostas diretas para as dúvidas mais comuns.
          </p>
        </motion.div>

        <div className="space-y-4">
          {faqs.map((faq, idx) => (
            <SpotlightCard key={idx} innerClassName="w-full h-auto">
              <button
                onClick={() => setActiveIndex(activeIndex === idx ? null : idx)}
                className="w-full flex items-center justify-between p-6 text-left"
              >
                <span className="text-foreground font-bold text-lg">{faq.question}</span>
                <ChevronDown 
                  className={`text-orange-500 transition-transform duration-500 ${activeIndex === idx ? 'rotate-180' : ''}`} 
                  size={24} 
                />
              </button>
              
              <AnimatePresence>
                {activeIndex === idx && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: 'auto', opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3 }}
                    className="overflow-hidden"
                  >
                    <div className="p-6 pt-0 text-slate-400 leading-relaxed">
                      {faq.answer}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </SpotlightCard>
          ))}
        </div>
      </div>
    </section>
  );
}
